import { useEffect, useState } from "react";
import WebSocketService from "../../../contexts/WebSocketService";
import useUser from "../../../hooks/useUser";
import { getBearerToken } from "../../../utils/Functions";
import usePageVisibility from "./usePageVisibility";
import logger from "../../../utils/logger";

export default function useMessageWebsocket(convoId, isReceiver = false) {
  const { roles } = useUser();
  const isTabActive = usePageVisibility();

  const [messageUpdates, setMessageUpdates] = useState([]);

  useEffect(() => {
    if (!isReceiver || !isTabActive || convoId == null) return;

    const path = "messages";
    let webSocketService = null;
    let isMounted = true;

    const connectToWebSocket = async () => {
      try {
        const token = await getBearerToken();
        webSocketService = new WebSocketService(token, path, convoId);

        webSocketService.connect((message) => {
          if (!isMounted) return;

          const messageIds = message?.messagesToUpdate;
          if (message?.messageRead && Array.isArray(messageIds) && messageIds.length > 0) {
            setMessageUpdates(messageIds);
          }
        });
      } catch (error) {
        logger.error("WebSocket connection error:", error);
      }
    };

    connectToWebSocket();

    return () => {
      isMounted = false;
      if (webSocketService) {
        webSocketService.disconnect();
      }
    };
  }, [convoId, isReceiver, isTabActive, roles?.master]);

  return messageUpdates;
}
